export const GLOSSARY = [
  {
    "key": 1,
    "value": "acceptable use policy (AUP)",
    "description": "Organizational policy that describes both acceptable and unac-ceptable actions when using organizational computing resources, as well as the consequences of violating the policy."
  },
  {
    "key": 2,
    "value": "access cloning",
    "description": "The practice of provisioning access for a person by duplicating another per-son\u2019s access rights."
  },
  {
    "key": 3,
    "value": "access control",
    "description": "The processes and technologies involved in protecting information, systems, and data against unauthorized disclosure, modification, or loss by controlling access to those resources, physically and/or logically."
  },
  {
    "key": 4,
    "value": "access deprovisioning",
    "description": "The act of removing a user\u2019s or system\u2019s access to a dataset, database, application, or system."
  },
  {
    "key": 5,
    "value": "access provisioning",
    "description": "The act of configuring a user\u2019s or system\u2019s access to a dataset, database, application, or system."
  },
  {
    "key": 6,
    "value": "access review",
    "description": "A review of access rights to determine whether the access rights to a system continue to be allowed."
  },
  {
    "key": 7,
    "value": "accountability",
    "description": "The ability to trace an action or event to a specific subject and to hold that subject responsible for their actions."
  },
  {
    "key": 8,
    "value": "administrative account separation",
    "description": "Maintaining distinct privileged and standard user accounts for administrators."
  },
  {
    "key": 9,
    "value": "administrative control",
    "description": "A control that exists in the form of a policy or procedure. See also technical control."
  },
  {
    "key": 10,
    "value": "after-action review (AAR)",
    "description": "A review of a recent project, event, or incident, to identify areas of effectiveness and areas of needed improvement."
  },
  {
    "key": 11,
    "value": "aggregation",
    "description": "See data aggregation."
  },
  {
    "key": 12,
    "value": "Agile",
    "description": "A systems development methodology that delivers features and capabilities incremen-tally. See also Scrum."
  },
  {
    "key": 13,
    "value": "AIC triad",
    "description": "See CIA triad."
  },
  {
    "key": 14,
    "value": "annual loss expectancy (ALE)",
    "description": "In quantitative risk analysis, the expected loss of asset value due to threat realization. ALE is defined as the single loss expectancy (SLE) \u00d7 the annualized rate of occurrence (ARO)."
  },
  {
    "key": 15,
    "value": "annualized rate of occurrence (ARO)",
    "description": "In quantitative risk analysis, an estimate of the number of times that a threat will occur every year. bbgglloossss__oonnlliinnee..iinndddd 2222//1188//22002266 1111::5544::2266 AAMM"
  },
  {
    "key": 16,
    "value": "Anything-as-a-Service (XaaS)",
    "description": "See Everything-as-a-Service (XaaS)."
  },
  {
    "key": 17,
    "value": "application programming interface (API)",
    "description": "A specification for, and the connection between, two or more software programs, usually on different systems."
  },
  {
    "key": 18,
    "value": "architecture review",
    "description": "The examination of the architecture of a system or process to determine whether it is sound and meets stated objectives."
  },
  {
    "key": 19,
    "value": "archival",
    "description": "Migration of data from an active database or dataset to a long-term storage system for long-term retention."
  },
  {
    "key": 20,
    "value": "artificial intelligence (AI)",
    "description": "A class of software systems designed to perform tasks that gener-ally require human cognitive abilities, such as pattern recognition, decision-making, predic-tion, or language processing."
  },
  {
    "key": 21,
    "value": "assessment",
    "description": "The process of determining whether a program, project, or control is meet-ing specified objectives, as well as whether the controls selected to protect the system are performing their desired function to the required level."
  },
  {
    "key": 22,
    "value": "asset",
    "description": "Anything of value to an organization; assets can include tangible items such as infor-mation, data, equipment, supplies, facilities, and systems, as well as intangible items such as virtual machines, customer loyalty, and reputation."
  },
  {
    "key": 23,
    "value": "asset discovery",
    "description": "The use of tools to examine IT environments to identify changes to the inventory of assets."
  },
  {
    "key": 24,
    "value": "asset management",
    "description": "Processes and records used in the oversight of inventory, classification, use, and disposal of assets."
  },
  {
    "key": 25,
    "value": "asset valuation",
    "description": "The practice of assigning monetary value to an asset."
  },
  {
    "key": 26,
    "value": "asset value (AV)",
    "description": "In quantitative risk analysis, the replacement cost of an asset."
  },
  {
    "key": 27,
    "value": "attack",
    "description": "An offensive action that results in potential harm to an asset."
  },
  {
    "key": 28,
    "value": "attack surface",
    "description": "The set of components that could be the target of an attack by an adversary."
  },
  {
    "key": 29,
    "value": "audit",
    "description": "A formal inspection of a control, process, or system to determine whether it is being followed, operates effectively, and meets its objectives."
  },
  {
    "key": 30,
    "value": "authentication",
    "description": "The process of validating credentials a user has supplied to verify that they are the actual authorized user and that the credentials belong to that user."
  },
  {
    "key": 31,
    "value": "authorization",
    "description": "The process of giving authenticated users the proper access to systems, data, and facilities."
  },
  {
    "key": 32,
    "value": "availability",
    "description": "The goal of having information and systems available to authorized users when-ever and however they need them. bbgglloossss__oonnlliinnee..iinndddd 3322//1188//22002266 1111::5544::2266 AAMM"
  },
  {
    "key": 33,
    "value": "background check",
    "description": "An investigation into the education, employment, criminal, and financial background of a person considered for employment."
  },
  {
    "key": 34,
    "value": "bias",
    "description": "A systematic deviation in an AI system\u2019s predictions or decisions that favors specific outcomes or groups over others. Bias can result from skewed data, flawed model design, or human assumptions."
  },
  {
    "key": 35,
    "value": "bow-tie analysis",
    "description": "A risk analysis technique used to depict the relationships between various elements of risk."
  },
  {
    "key": 36,
    "value": "brainstorming",
    "description": "A problem-solving technique in which participants spontaneously generate potential solutions for discussion and analysis."
  },
  {
    "key": 37,
    "value": "business alignment",
    "description": "The concept of developing policies, processes, and procedures that align with an organization\u2019s mission, goals, objectives, size, sector, and culture."
  },
  {
    "key": 38,
    "value": "business associate agreement (BAA)",
    "description": "A legal agreement between two organizations that imposes obligations on one or more parties."
  },
  {
    "key": 39,
    "value": "business case",
    "description": "In the context of risk management, a written or oral presentation that explains the reasoning for the expense and effort associated with risk response."
  },
  {
    "key": 40,
    "value": "business continuity management",
    "description": "The high-level, overall effort to ensure that an organiza-tion\u2019s critical processes and functions will be able to continue operations despite disruptive incidents."
  },
  {
    "key": 41,
    "value": "business continuity planning",
    "description": "The process, typically detailed in a supporting plan, that keeps the company operating in the event of a power outage, IT malfunction, or major disaster. See also disaster recovery planning, IT service continuity management (ITSCM)."
  },
  {
    "key": 42,
    "value": "business impact analysis (BIA)",
    "description": "The process of analyzing critical business processes, the assets that support them, and their impact when a loss of or disruption in access to those assets occurs."
  },
  {
    "key": 43,
    "value": "business process",
    "description": "See process."
  },
  {
    "key": 44,
    "value": "business process outsourcing (BPO)",
    "description": "The process of outsourcing one or more business processes to a service provider."
  },
  {
    "key": 45,
    "value": "business resilience",
    "description": "See resilience."
  },
  {
    "key": 46,
    "value": "business-technology alignment",
    "description": "See business alignment."
  },
  {
    "key": 47,
    "value": "capability",
    "description": "The set of organizational competencies, resources, processes, and maturity levels that enable the organization to manage risk and implement risk responses effectively. bbgglloossss__oonnlliinnee..iinndddd 4422//1188//22002266 1111::5544::2266 AAMM"
  },
  {
    "key": 48,
    "value": "Capability Maturity Model Integration (CMMI)",
    "description": "A business process maturity model devel-oped by Carnegie Mellon University and now owned by ISACA."
  },
  {
    "key": 49,
    "value": "Center for Internet Security (CIS) Controls",
    "description": "A control framework published by the Center for Internet Security."
  },
  {
    "key": 50,
    "value": "change management",
    "description": "The overall process for managing the request, review, approval, and execution of changes to IT systems or business processes."
  },
  {
    "key": 51,
    "value": "CI/CD",
    "description": "See continuous integration/continuous delivery (CI/CD)."
  },
  {
    "key": 52,
    "value": "CIA triad",
    "description": "The three security principles of confidentiality, integrity, and availability."
  },
  {
    "key": 53,
    "value": "classification level",
    "description": "A designation assigned to an asset for the purpose of determining an appropriate protection regimen."
  },
  {
    "key": 54,
    "value": "COBIT",
    "description": "A management and governance framework developed and used extensively by ISACA in its various risk management and business process frameworks."
  },
  {
    "key": 55,
    "value": "code review",
    "description": "A manual examination of software source code to identify defects, including those that may be exploited by an attacker. See also code scan."
  },
  {
    "key": 56,
    "value": "code scan",
    "description": "An automated examination of software source code to identify defects. See also code review."
  },
  {
    "key": 57,
    "value": "common control",
    "description": "A control spanning the entire organization that protects multiple assets rather than only a specific asset. A physical control is a good example of a common control, and the responsible entity for that control would be the common controls provider."
  },
  {
    "key": 58,
    "value": "Common Vulnerability Scoring System (CVSS)",
    "description": "A standardized framework for rating the severity of security vulnerabilities."
  },
  {
    "key": 59,
    "value": "compensating control",
    "description": "An alternative control that provides security protection comparable to a required or primary control, when the primary control cannot be implemented. See also corrective control, deterrent control, detective control, preventive control, recovery control."
  },
  {
    "key": 60,
    "value": "confidentiality",
    "description": "The goal of protecting systems and information from unauthorized disclosure."
  },
  {
    "key": 61,
    "value": "configuration management",
    "description": "The use of recordkeeping to record changes made to configura-tion settings in an information system."
  },
  {
    "key": 62,
    "value": "configuration management database (CMDB)",
    "description": "An electronic record of configuration infor-mation for IT assets."
  },
  {
    "key": 63,
    "value": "continuous integration/continuous delivery (CI/CD)",
    "description": "A systems development and operations model that consists of automation and frequent code releases."
  },
  {
    "key": 64,
    "value": "control",
    "description": "A measure put in place to increase protection for an asset, to make up for a lack of protection for an asset, or to strengthen a weakness for an asset. Controls can be administra-tive, technical, or physical and operational. They can also be further divided by functionality (deterrent, preventative, detective, and so on). bbgglloossss__oonnlliinnee..iinndddd 5522//1188//22002266 1111::5544::2266 AAMM"
  },
  {
    "key": 65,
    "value": "control baseline",
    "description": "The initial set of controls selected, based on the security categorization to be applied to systems and data and maintained throughout their lifecycle."
  },
  {
    "key": 66,
    "value": "control deficiency",
    "description": "A situation where a control is not sufficient to meet its control objective. See also control objective."
  },
  {
    "key": 67,
    "value": "control deficiency analysis",
    "description": "The process of determining the difference between the existing state of a control\u2019s effectiveness and its desired state."
  },
  {
    "key": 68,
    "value": "control effectiveness",
    "description": "The measure of whether a control sufficiently meets its control objective."
  },
  {
    "key": 69,
    "value": "control gap",
    "description": "A situation where controls do not exist."
  },
  {
    "key": 70,
    "value": "control objective",
    "description": "An overarching statement describing the intent of a group of one or more controls."
  },
  {
    "key": 71,
    "value": "control ownership",
    "description": "The person or entity responsible for the proper implementation and maintenance of security controls within the organization."
  },
  {
    "key": 72,
    "value": "control rationalization",
    "description": "The process of evaluating, consolidating, and optimizing a control environment to ensure that controls are effective, efficient, non-redundant, and aligned with business objectives and governance requirements."
  },
  {
    "key": 73,
    "value": "corrective action",
    "description": "A one-time specific action taken to address the root cause of an identified issue, control failure, audit finding, or deviation, with the intent of eliminating the cause and preventing recurrence. See also preventive action."
  },
  {
    "key": 74,
    "value": "corrective control",
    "description": "A control used to restore normal operations of a system or process. See also compensating control, detective control, deterrent control, preventive control, recovery control."
  },
  {
    "key": 75,
    "value": "COSO Enterprise Risk Management (ERM) Framework",
    "description": "A risk management governance framework developed by the Committee of Sponsoring Organizations of the Treadway Commission (COSO)."
  },
  {
    "key": 76,
    "value": "criticality analysis",
    "description": "A study of each system and process, a consideration of the impact on the organization if it is incapacitated, the likelihood of incapacitation, and the estimated cost of mitigating the risk or impact of incapacitation."
  },
  {
    "key": 77,
    "value": "culture",
    "description": "The values and norms in an organization that define how people treat each other and work together to achieve organizational objectives."
  },
  {
    "key": 78,
    "value": "dark risk",
    "description": "An informal term in cybersecurity risk management that represents unidentified risk, such as the risk of compromise to assets not included in the asset inventory."
  },
  {
    "key": 79,
    "value": "data aggregation",
    "description": "The process of combining data from multiple records, datasets, or sources to create a more comprehensive or detailed view. bbgglloossss__oonnlliinnee..iinndddd 6622//1188//22002266 1111::5544::2266 AAMM"
  },
  {
    "key": 80,
    "value": "data classification",
    "description": "Policies that define sensitivity levels and handling procedures, and con-trols used to protect information at various levels."
  },
  {
    "key": 81,
    "value": "data destruction",
    "description": "The willful or malicious destruction of data that renders it unavailable for intended uses."
  },
  {
    "key": 82,
    "value": "data discovery",
    "description": "A manual or automated technique in which a target system is examined to determine the presence of specific types of data; additionally, this may include an examination of access rights to particular sets of data."
  },
  {
    "key": 83,
    "value": "data lineage",
    "description": "A formal description of additions, changes, and deletions made to data after its acquisition or creation."
  },
  {
    "key": 84,
    "value": "data loss prevention (DLP)",
    "description": "An automated system that monitors the use and movement of data files within the organization and, when warranted, enforces data classification policy."
  },
  {
    "key": 85,
    "value": "data minimization",
    "description": "The practice of receiving and storing only those data records and data fields necessary to perform business operations."
  },
  {
    "key": 86,
    "value": "data provenance",
    "description": "A formal description of the origin of a database or dataset."
  },
  {
    "key": 87,
    "value": "data retention schedule",
    "description": "A policy that defines the minimum and/or maximum retention periods for various databases, datasets, and data types."
  },
  {
    "key": 88,
    "value": "data sensitivity",
    "description": "The level of protection required for information or data based on its impact on the organization if it were disclosed to unauthorized people, subject to unauthorized mod-ification, or otherwise lost."
  },
  {
    "key": 89,
    "value": "data subject",
    "description": "A natural person to whom personal data relates and who can be identified, directly or indirectly, by that data."
  },
  {
    "key": 90,
    "value": "database",
    "description": "A collection of data in electronic form used for an identified business purpose and generally structured to support efficient management and use."
  },
  {
    "key": 91,
    "value": "database management system (DBMS)",
    "description": "A software program that manages access and modi-fications to one or more databases."
  },
  {
    "key": 92,
    "value": "Deming cycle",
    "description": "A generic business lifecycle model consisting of \u201cPlan,\u201d \u201cDo,\u201d \u201cCheck,\u201d and \u201cAct.\u201d"
  },
  {
    "key": 93,
    "value": "denial of service (DoS)",
    "description": "An attack on a system that renders it unavailable for legitimate use. A DoS attack works in one of two ways: first, by overwhelming a target system with a large volume of data; or second, by sending malicious data to a target system that will result in its incapacitation."
  },
  {
    "key": 94,
    "value": "design review",
    "description": "The examination of the design of a system or process to determine whether it is sound and meets stated objectives."
  },
  {
    "key": 95,
    "value": "detective control",
    "description": "A control that detects, but does not prevent, policy violations and other unwanted events. See also compensating control, corrective control, detective control, deter-rent control, preventive control, recovery control. bbgglloossss__oonnlliinnee..iinndddd 7722//1188//22002266 1111::5544::2266 AAMM"
  },
  {
    "key": 96,
    "value": "deterrent control",
    "description": "A control that deters individuals from performing unwanted actions. See also compensating control, corrective control, detective control, deterrent control, pre-ventive control, recovery control."
  },
  {
    "key": 97,
    "value": "device hardening",
    "description": "Configurations applied to a system or device to make it more resistant to attack."
  },
  {
    "key": 98,
    "value": "DevOps",
    "description": "An integrated systems development and operations model that relies on automated testing and release."
  },
  {
    "key": 99,
    "value": "DevSecOps",
    "description": "A DevOps model that includes security controls and testing."
  },
  {
    "key": 100,
    "value": "disaster recovery (DR)",
    "description": "The process of reacting to an incident or disaster and recovering IT systems to a functioning state. See also business continuity planning, IT service continuity management (ITSCM)."
  },
  {
    "key": 101,
    "value": "due care",
    "description": "The process of taking the necessary responsibility and steps to protect an organiza-tion and its workers."
  },
  {
    "key": 102,
    "value": "due diligence",
    "description": "The reasonable amount of investigation taken prior to entering into a legal agreement."
  },
  {
    "key": 103,
    "value": "due process",
    "description": "An impartial and fair inquiry into violations of organization policy."
  },
  {
    "key": 104,
    "value": "dynamic application security testing (DAST)",
    "description": "Tools that execute a software application to perform various attack simulations to identify defects and vulnerabilities. See also static appli-cation security testing (SAST), software composition analysis (SCA)."
  },
  {
    "key": 105,
    "value": "eavesdropping",
    "description": "An attack in which an attacker is able to observe network traffic."
  },
  {
    "key": 106,
    "value": "economy of use",
    "description": "The design principle that states one should attempt to design and implement controls that can be applied to more than one system or set of data, or that provide more than one function, to effectively mitigate risk. The goal is to minimize single-use controls (controls that apply only to a specific system or set of data) because they can be more expensive and specialized to implement."
  },
  {
    "key": 107,
    "value": "effectiveness",
    "description": "The extent to which the response reduces the likelihood or the impact of the risk event to the organization; also, the degree and depth to which a control fulfills its security requirements. See also control effectiveness."
  },
  {
    "key": 108,
    "value": "encryption",
    "description": "A mathematical technique in which data is scrambled, so that it cannot be read by anyone who does not possess its encryption key."
  },
  {
    "key": 109,
    "value": "end-user behavioral analysis (EUBA)",
    "description": "Tooling that learns routine end-user behavior and gen-erates alerts when behavior deviates from normal."
  },
  {
    "key": 110,
    "value": "enterprise architecture",
    "description": "A structured framework that describes how an organization\u2019s business processes, information, applications, and technology infrastructure are designed and integrated to support business objectives and manage risk. bbgglloossss__oonnlliinnee..iinndddd 8822//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 111,
    "value": "enterprise risk management (ERM)",
    "description": "The practice of identifying and managing strategic risk in an organization."
  },
  {
    "key": 112,
    "value": "EU AI Act",
    "description": "A European regulatory framework that governs the development, deployment, and use of AI systems in the European Union."
  },
  {
    "key": 113,
    "value": "event",
    "description": "An instance of threat realization."
  },
  {
    "key": 114,
    "value": "event-tree analysis",
    "description": "A bottom-up risk analysis technique that focuses on all possible risk impacts and looks for all possible risk events."
  },
  {
    "key": 115,
    "value": "Everything-as-a-Service (XaaS)",
    "description": "The entirety of Software-as-a-Service (SaaS), Platform-as-a-Service (PaaS), Infrastructure-as-a-Service (IaaS), and other cloud-based service offerings."
  },
  {
    "key": 116,
    "value": "evidence",
    "description": "Documents, records, and other artifacts gathered in an assessment or audit."
  },
  {
    "key": 117,
    "value": "exception management",
    "description": "The process of accepting, documenting, and tracking exceptions to security policies and risk mitigation strategies."
  },
  {
    "key": 118,
    "value": "exfiltration",
    "description": "The unauthorized transmission of data from an organization to an outside destination."
  },
  {
    "key": 119,
    "value": "explainability",
    "description": "A characteristic of an AI system in which humans can explain its decisions or outputs."
  },
  {
    "key": 120,
    "value": "exploit",
    "description": "1) A specific tool or method that can be used to carry out a threat. 2) The act of attacking an asset, made easier by the presence of a vulnerability."
  },
  {
    "key": 121,
    "value": "exposure factor (EF)",
    "description": "In quantitative risk analysis, the financial loss that results from threat realization, expressed as a percentage of the asset\u2019s total value."
  },
  {
    "key": 122,
    "value": "extraterritorial law",
    "description": "A statute or regulation enacted by a country that applies to conduct occurring outside its borders when the activity has a substantial connection or effect within that country\u2019s jurisdiction."
  },
  {
    "key": 123,
    "value": "Factor Analysis of Information Risk (FAIR)",
    "description": "A risk analysis methodology used to assess the factors contributing to individual risks."
  },
  {
    "key": 124,
    "value": "false negative",
    "description": "A situation where a vulnerability isn\u2019t detected but does actually exist."
  },
  {
    "key": 125,
    "value": "false positive",
    "description": "A situation where a vulnerability is reported that isn\u2019t legitimate."
  },
  {
    "key": 126,
    "value": "Family Educational Rights and Privacy Act (FERPA)",
    "description": "A U.S. law protecting the privacy of student education records in educational institutions."
  },
  {
    "key": 127,
    "value": "fault-tree analysis",
    "description": "A top-down risk analysis technique that focuses on risk events and looks for all possible causes of the event. bbgglloossss__oonnlliinnee..iinndddd 9922//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 128,
    "value": "firewall",
    "description": "A network device configured with one or more rules that determine which network traffic is permitted to pass and which is not."
  },
  {
    "key": 129,
    "value": "forensics",
    "description": "An investigative technique in which details are examined to determine the sequence of events, usually after a security incident."
  },
  {
    "key": 130,
    "value": "framework",
    "description": "An overall methodology prescribing higher-level processes or controls."
  },
  {
    "key": 131,
    "value": "fuzzing",
    "description": "A technique used to generate various forms of input to a system to identify potential vulnerabilities that could allow an attacker to compromise the system."
  },
  {
    "key": 132,
    "value": "gap assessment",
    "description": "An examination of a system or process to determine whether it complies with established requirements or standards."
  },
  {
    "key": 133,
    "value": "gateway",
    "description": "A system that controls, transforms, or buffers the flow of information between dif-ferent systems or networks."
  },
  {
    "key": 134,
    "value": "General Data Protection Regulation (GDPR)",
    "description": "An extraterritorial European privacy law enacted in 2018 and serves to protect the personal data and privacy of individuals located in the European Union."
  },
  {
    "key": 135,
    "value": "governance",
    "description": "Management\u2019s control over policies, processes, and operations."
  },
  {
    "key": 136,
    "value": "governance, risk, and compliance (GRC) system",
    "description": "See integrated risk management (IRM) system."
  },
  {
    "key": 137,
    "value": "Gramm-Leach-Bliley Act (GLBA)",
    "description": "U.S. law that requires financial institutions (including banks, loan companies, insurance companies, and investment companies) to protect sensitive financial data and make their information-sharing practices known to their customers. Of par-ticular interest to security professionals is the Safeguards Rule incorporated into GLBA, which requires institutions under the jurisdiction of the Federal Trade Commission to have specific measures in place to protect customer information."
  },
  {
    "key": 138,
    "value": "guideline",
    "description": "A recommended practice for implementing a policy."
  },
  {
    "key": 139,
    "value": "hardening",
    "description": "Steps taken to make a system or device more resilient and resistant to attack."
  },
  {
    "key": 140,
    "value": "Health Insurance Portability and Accountability Act (HIPAA)",
    "description": "A U.S. law enacted in 1996 requiring the U.S. government\u2019s Health and Human Services Department to establish require-ments for protecting the privacy and security of personal health information (PHI). The two important elements of HIPAA of interest to security professionals are the HIPAA Privacy Rule and the HIPAA Security Rule, which set forth specific standards to protect electronic PHI. bbgglloossss__oonnlliinnee..iinndddd 110022//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 141,
    "value": "Heisenberg\u2019s Risk",
    "description": "A risk whose likelihood or impact changes as measurement and reporting increase, making precise assessment difficult without influencing outcomes."
  },
  {
    "key": 142,
    "value": "identification",
    "description": "The process of presenting credentials to a system to identify an authorized user. Identification is often followed by authentication. See also authentication."
  },
  {
    "key": 143,
    "value": "identity proofing",
    "description": "Steps taken to confirm the identity of a person requesting access."
  },
  {
    "key": 144,
    "value": "IEC 31010",
    "description": "An international standard for risk management and risk assessment techniques. See also ISO/IEC."
  },
  {
    "key": 145,
    "value": "immutable backup",
    "description": "Backup media that cannot be overwritten, used to improve the resilience of backup data and defend against threats such as ransomware."
  },
  {
    "key": 146,
    "value": "impact",
    "description": "The level of potential harm or damage to an asset or the organization if a given threat were to exploit a given vulnerability."
  },
  {
    "key": 147,
    "value": "incident",
    "description": "An unplanned event that causes, or has the potential to cause, harm, loss, disrup-tion, or degradation of objectives, operations, or services. See also security incident."
  },
  {
    "key": 148,
    "value": "incident management",
    "description": "Processes to respond to and remediate events and incidents, including security and privacy incidents. See also problem management."
  },
  {
    "key": 149,
    "value": "incident response plan (IRP)",
    "description": "A plan that defines roles, responsibilities, authorities, commu-nication paths, decision-making processes, and required actions before, during, and after a security incident."
  },
  {
    "key": 150,
    "value": "indicators of compromise",
    "description": "Observations on a network or in an operating system that indicate a network or computer intrusion. See also threat hunting."
  },
  {
    "key": 151,
    "value": "information security policy",
    "description": "Corporate policy concerning information security topics, appli-cable to personnel, processes, and systems."
  },
  {
    "key": 152,
    "value": "Infrastructure-as-a-Service (IaaS)",
    "description": "A third-party cloud-based service that offers outsourced use of IT infrastructure, including server operating systems, database management systems, and network devices like routers and firewalls. This allows an organization to use IT infra-structure at a lower cost than buying, installing, and maintaining hardware and software. See also Everything-as-a-Service (XaaS), Platform-as-a-Service (PaaS), and Software-as-a-Service (SaaS)."
  },
  {
    "key": 153,
    "value": "Infrastructure-as-Code (IaC)",
    "description": "The use of CI/CD techniques to manage the architecture and configuration of infrastructure components. See also continuous integration/continuous deliv-ery (CI/CD)."
  },
  {
    "key": 154,
    "value": "inherent risk",
    "description": "The level of risk associated with a specific activity or function, prior to applying any protective controls or safeguards. bbgglloossss__oonnlliinnee..iinndddd 111122//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 155,
    "value": "insider threat",
    "description": "The result of human error, skill gaps, insufficient training, insufficient staffing, and malicious actions."
  },
  {
    "key": 156,
    "value": "integrated risk management (IRM) system",
    "description": "An information system used to track and manage various governance, risk, and compliance activities, including risk management."
  },
  {
    "key": 157,
    "value": "integration testing",
    "description": "The testing of components of a system to determine whether they inter-operate as expected. See also interface testing, security testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 158,
    "value": "integrity",
    "description": "The goal of preventing unauthorized modification to a system or data."
  },
  {
    "key": 159,
    "value": "interface testing",
    "description": "The testing of a system\u2019s interfaces and APIs to determine whether they interoperate as expected. See also integration testing, security testing, unit testing, user accep-tance testing (UAT)."
  },
  {
    "key": 160,
    "value": "interoperability testing",
    "description": "Testing to determine whether various components in a process and/ or system work together properly."
  },
  {
    "key": 161,
    "value": "intrusion prevention system (IPS)",
    "description": "A system or device that is used to identify and block net-work traffic that may be an indication of an attempted intrusion."
  },
  {
    "key": 162,
    "value": "ISO/IEC",
    "description": "The International Organization for Standardization (ISO) and the International Electrotechnical Commission (IEC), which together are responsible for many of the informa-tion technology standards used worldwide, including several that apply to information secu-rity and risk management."
  },
  {
    "key": 163,
    "value": "ISO/IEC 20000",
    "description": "An international IT service management standard. See also IT Infrastructure Library (ITIL). See also ISO/IEC."
  },
  {
    "key": 164,
    "value": "ISO/IEC 27001 series",
    "description": "A set of international standards concerning information security gov-ernance and risk management. See also ISO/IEC."
  },
  {
    "key": 165,
    "value": "ISO 31000",
    "description": "An international standard framework for risk management. See also ISO/IEC."
  },
  {
    "key": 166,
    "value": "ISO 31010",
    "description": "See IEC 31010."
  },
  {
    "key": 167,
    "value": "IT general control (ITGC)",
    "description": "A control that is applied across all information systems and sup-porting processes in an organization."
  },
  {
    "key": 168,
    "value": "IT Infrastructure Library (ITIL)",
    "description": "An international IT service management standard. See also ISO/IEC 20000."
  },
  {
    "key": 169,
    "value": "IT service continuity management (ITSCM)",
    "description": "Practices to ensure that critical IT services can continue or be restored to acceptable levels following a disruption. See also business continu-ity planning, disaster recovery planning."
  },
  {
    "key": 170,
    "value": "IT service management",
    "description": "The suite of activities performed by an IT department to build and sustain IT systems. bbgglloossss__oonnlliinnee..iinndddd 112222//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 171,
    "value": "job rotation",
    "description": "A practice where an organization occasionally moves personnel from one job to another to help prevent practices contrary to policy."
  },
  {
    "key": 172,
    "value": "key control indicator (KCI)",
    "description": "A specific indicator that shows the relative effectiveness of a control."
  },
  {
    "key": 173,
    "value": "key performance indicator (KPI)",
    "description": "A specific indicator used to understand and enable the measurement of the performance of a process or system."
  },
  {
    "key": 174,
    "value": "key risk indicator (KRI)",
    "description": "An indicator designed to accurately predict an important level of risk based on a defined threshold."
  },
  {
    "key": 175,
    "value": "least privilege",
    "description": "A security principle that dictates that subjects should be given only the minimum level of rights, permissions, and privileges necessary to perform their designated functions or jobs, and no more than that."
  },
  {
    "key": 176,
    "value": "legal hold",
    "description": "A notice from an organization\u2019s legal department advising that specific data should not be modified or deleted, in response to an anticipated legal discovery process."
  },
  {
    "key": 177,
    "value": "lifecycle",
    "description": "A characteristic of a business process where a sequence of activities is repeated."
  },
  {
    "key": 178,
    "value": "likelihood",
    "description": "The certainty that an incident will occur; often expressed statistically as a probability."
  },
  {
    "key": 179,
    "value": "Likert scale",
    "description": "A scale widely used in semi-quantitative risk analysis and other disciplines that uses simple numeric ranges, such as 1\u20135."
  },
  {
    "key": 180,
    "value": "logical control",
    "description": "See technical control."
  },
  {
    "key": 181,
    "value": "machine learning (ML)",
    "description": "A subset of artificial intelligence in which software systems use algo-rithms and statistical models to learn patterns from data and improve performance on specific tasks without being explicitly programmed."
  },
  {
    "key": 182,
    "value": "man-in-the-middle attack (MITM)",
    "description": "An attack in which an attacker is able to intercept and alter communications between two or more systems. bbgglloossss__oonnlliinnee..iinndddd 113322//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 183,
    "value": "managerial control",
    "description": "See administrative control."
  },
  {
    "key": 184,
    "value": "mandatory vacation",
    "description": "A practice where an organization requires that each employee use a minimum amount of vacation each year to provide the opportunity for audit, security, and privacy specialists to examine the employee\u2019s practices or records during their absence."
  },
  {
    "key": 185,
    "value": "materiality",
    "description": "A quantitative or qualitative expression of significance."
  },
  {
    "key": 186,
    "value": "maturity",
    "description": "The degree of formality and optimization of a business process or capability."
  },
  {
    "key": 187,
    "value": "maturity assessment",
    "description": "An assessment of processes or capabilities to determine their maturity. See also maturity."
  },
  {
    "key": 188,
    "value": "maximum tolerable downtime (MTD)",
    "description": "A theoretical period, measured from the onset of a disaster, after which the organization\u2019s ongoing viability would be at risk."
  },
  {
    "key": 189,
    "value": "mean time to recover (MTTR)",
    "description": "The actual time required to restore a system during disaster recovery testing."
  },
  {
    "key": 190,
    "value": "metrics",
    "description": "Measurements of business processes or systems to understand workload, perfor-mance, or quality."
  },
  {
    "key": 191,
    "value": "mission",
    "description": "The stated reason for an organization\u2019s existence."
  },
  {
    "key": 192,
    "value": "model drift",
    "description": "The degradation of an AI model\u2019s accuracy over time as data patterns change."
  },
  {
    "key": 193,
    "value": "move to the left",
    "description": "See shift left."
  },
  {
    "key": 194,
    "value": "multifactor authentication (MFA)",
    "description": "Any means used to authenticate a user that is stronger than just the use of a user ID and password. Examples of multifactor authentication include digital certificates, tokens, smart cards, and biometrics."
  },
  {
    "key": 195,
    "value": "need-to-know",
    "description": "A security concept that requires a subject have an actual requirement to access systems or data, based on their job requirements."
  },
  {
    "key": 196,
    "value": "network",
    "description": "A mechanism that facilitates communication between systems."
  },
  {
    "key": 197,
    "value": "NIST",
    "description": "The U.S. Department of Commerce\u2019s National Institute of Standards and Technology, a standards development organization."
  },
  {
    "key": 198,
    "value": "NIST Cybersecurity Framework (CSF)",
    "description": "A voluntary, risk-based framework that provides a structured set of functions, categories, and outcomes to help organizations manage, reduce, and communicate cybersecurity risk across identify, protect, detect, respond, and recover activities."
  },
  {
    "key": 199,
    "value": "NIST Risk Management Framework (RMF)",
    "description": "The overall risk management methodology published and promulgated by the National Institute of Standards and Technology (NIST) in Special Publication 800-37. bbgglloossss__oonnlliinnee..iinndddd 114422//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 200,
    "value": "non-disclosure agreement (NDA)",
    "description": "A legal agreement in which one or more parties agree to maintain the confidentiality of information provided to them."
  },
  {
    "key": 201,
    "value": "non-repudiation",
    "description": "The security concept that requires a subject to be accountable for their actions, such that they cannot deny that they took an action."
  },
  {
    "key": 202,
    "value": "OCTAVE",
    "description": "The Operationally Critical Threat, Asset, and Vulnerability Evaluation (OCTAVE) methodology developed by Carnegie Mellon University and the U.S. government to assist organizations in identifying and assessing information security risk."
  },
  {
    "key": 203,
    "value": "operating system",
    "description": "Software that manages computer hardware and software resources and facilitates the use of programs and applications."
  },
  {
    "key": 204,
    "value": "operational control",
    "description": "See physical control."
  },
  {
    "key": 205,
    "value": "operational risk",
    "description": "1) Mid-term, cross-functional risk affecting how multiple work units interact and how business functions are performed. It spans processes and units and reflects risks in ongoing business operations. 2) The potential for loss, disruption, or reduced performance resulting from failures in processes, technology, or people. See also strategic risk, tactical risk."
  },
  {
    "key": 206,
    "value": "password cracker",
    "description": "A software tool that attempts to discover a password through analysis of a password in encrypted or hashed form."
  },
  {
    "key": 207,
    "value": "Payment Card Industry Data Security Standard (PCI DSS)",
    "description": "A set of security requirements levied on merchants that process credit card transactions by the major payment card industry providers, including Discover, Visa, MasterCard, and American Express. PCI DSS was devel-oped to impose security requirements and controls on retailers (merchants and service pro-viders) to reduce credit card fraud and identity theft."
  },
  {
    "key": 208,
    "value": "penetration test",
    "description": "An authorized assessment that actively identifies and exploits vulnerabilities or weaknesses in a system or process."
  },
  {
    "key": 209,
    "value": "people risk",
    "description": "See insider threat."
  },
  {
    "key": 210,
    "value": "personally identifiable information (PII)",
    "description": "Data elements that uniquely identify a natural person. See also privacy."
  },
  {
    "key": 211,
    "value": "physical control",
    "description": "A control associated with the security of personnel, equipment, and facil-ities. See also administrative control, technical control. bbgglloossss__oonnlliinnee..iinndddd 115522//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 212,
    "value": "platform",
    "description": "A hardware, software, or cloud infrastructure upon which to base computing operating systems, applications, and networks. It may involve different operating systems, network protocols, or particular types of hardware."
  },
  {
    "key": 213,
    "value": "Platform-as-a-Service (PaaS)",
    "description": "A third-party cloud-based service that provides outsourced access to application platforms; this allows an organization to integrate its business applica-tions with these platforms to expand their functionality and value."
  },
  {
    "key": 214,
    "value": "policy",
    "description": "Formal statements of intended outcomes and characteristics of personnel, business processes, and information systems."
  },
  {
    "key": 215,
    "value": "port scanner",
    "description": "A software program that determines which ports on a target system are listen-ing for incoming requests. See also vulnerability scanner."
  },
  {
    "key": 216,
    "value": "portfolio",
    "description": "A grouping of programs managed as a whole. Portfolio management involves the oversight of several different programs by a senior person in the organization."
  },
  {
    "key": 217,
    "value": "practice",
    "description": "A proven, standardized methodology or way of performing particular tasks or processes."
  },
  {
    "key": 218,
    "value": "preventive action",
    "description": "A measure taken to prevent an unwanted event from occurring. See also corrective action."
  },
  {
    "key": 219,
    "value": "preventive control",
    "description": "A control that prevents an unwanted event or incident. See also compen-sating control, corrective control, detective control, deterrent control, recovery control."
  },
  {
    "key": 220,
    "value": "privacy",
    "description": "The principles and practices of protecting the personally identifiable information (PII) of customers, constituents, and workers."
  },
  {
    "key": 221,
    "value": "privacy policy",
    "description": "A policy statement that describes how an organization uses data subjects\u2019 personal information."
  },
  {
    "key": 222,
    "value": "privileged access management (PAM)",
    "description": "The process and/or tooling to manage privileged user accounts, such as system administrators, network administrators, and domain administrators."
  },
  {
    "key": 223,
    "value": "probability",
    "description": "The chance that an event will occur."
  },
  {
    "key": 224,
    "value": "problem management",
    "description": "Processes to identify the root cause of chronic events and incidents. See also incident management."
  },
  {
    "key": 225,
    "value": "procedure",
    "description": "A sequenced list of steps to perform a task."
  },
  {
    "key": 226,
    "value": "process",
    "description": "A group of procedures that support a business function"
  },
  {
    "key": 227,
    "value": "process maturity",
    "description": "See maturity."
  },
  {
    "key": 228,
    "value": "process risk",
    "description": "Risk associated with inconsistent, incomplete, or poorly controlled business processes. bbgglloossss__oonnlliinnee..iinndddd 116622//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 229,
    "value": "program",
    "description": "1) A grouping of similar projects; programs are usually ongoing and longer-term in nature and may also encompass several individual projects. 2) Activities specific to processes that may have an indefinite duration."
  },
  {
    "key": 230,
    "value": "project",
    "description": "A limited-duration set of activities geared toward a particular goal; projects have definitive start and stop dates, resource allocations, scopes, schedules, and costs."
  },
  {
    "key": 231,
    "value": "project management",
    "description": "A set of processes covering a defined project from start to finish, gener-ally looking to cut costs such as time, scope, and overall project cost."
  },
  {
    "key": 232,
    "value": "protected health information (PHI)",
    "description": "As defined by HIPAA, healthcare-related information about individual persons."
  },
  {
    "key": 233,
    "value": "protocol analyzer",
    "description": "A hardware or software tool that collects network traffic for the purpose of examination, either for determining network issues or for capturing plaintext usernames, passwords, or other sensitive information being sent in the clear."
  },
  {
    "key": 234,
    "value": "provisioning",
    "description": "See access provisioning."
  },
  {
    "key": 235,
    "value": "qualitative assessment",
    "description": "An assessment technique that uses subjective values, such as low, moderate, and high, to describe various components of risk, such as likelihood and impact. Qualitative techniques rely on data that is often difficult to describe in numerical terms."
  },
  {
    "key": 236,
    "value": "quantitative assessment",
    "description": "An assessment technique that uses nonsubjective values, such as numerical or other measurable data, to describe components of risk, including likelihood and impact. Quantitative techniques rely on data that is numerically derived and not easily subject to individual opinion."
  },
  {
    "key": 237,
    "value": "quantum-resistant cryptography",
    "description": "Encryption algorithms that are resistant to quantum-powered algorithms that may be able to break cryptosystems."
  },
  {
    "key": 238,
    "value": "recovery capacity objective (RCapO)",
    "description": "The transaction processing capacity of an alterna-tive processing system, expressed as a percentage of the capacity of the primary processing system."
  },
  {
    "key": 239,
    "value": "recovery consistency objective (RCO)",
    "description": "The feature set of an alternative processing system, expressed as a percentage of the complete set of features of the primary processing system. bbgglloossss__oonnlliinnee..iinndddd 117722//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 240,
    "value": "recovery control",
    "description": "A control that restores availability and continuity of operations after a dis-ruption or failure. See also compensating control, corrective control, detective control, deter-rent control, preventive control."
  },
  {
    "key": 241,
    "value": "recovery point objective (RPO)",
    "description": "The maximum tolerable period in which data can be lost by the organization because of an incident or disaster."
  },
  {
    "key": 242,
    "value": "recovery time objective (RTO)",
    "description": "The maximum amount of time allowed to pass between an incident and recovering the business to an operational state."
  },
  {
    "key": 243,
    "value": "reference architecture",
    "description": "A formal design artifact for use when an organization needs to imple-ment additional information technology infrastructure."
  },
  {
    "key": 244,
    "value": "residual risk",
    "description": "The risk that remains after the application of risk treatment, acceptance, or transfer."
  },
  {
    "key": 245,
    "value": "resilience",
    "description": "The ability of the business to survive adverse events and continue with its mission and function."
  },
  {
    "key": 246,
    "value": "return on investment (ROI)",
    "description": "The ratio between investment and value received."
  },
  {
    "key": 247,
    "value": "risk",
    "description": "The possibility of harm that can come to an asset or an organization."
  },
  {
    "key": 248,
    "value": "risk acceptance",
    "description": "An active decision made to assume risk (either inherent or residual) and take no further action to reduce it."
  },
  {
    "key": 249,
    "value": "risk acceptance letter",
    "description": "A formal memo in which a business leader agrees to accept an identi-fied risk."
  },
  {
    "key": 250,
    "value": "risk analysis",
    "description": "The detailed examination of an individual risk identified in a risk assessment to determine its potential severity and impact."
  },
  {
    "key": 251,
    "value": "risk appetite",
    "description": "The organization\u2019s overall acceptable level of risk for a given business venture."
  },
  {
    "key": 252,
    "value": "risk assessment",
    "description": "The process of identifying and assessing various factors, including threats, threat actors, vulnerabilities, assets, and likelihood, to determine their impact on the organization."
  },
  {
    "key": 253,
    "value": "risk avoidance",
    "description": "A risk treatment option taken when the level of risk is still not acceptable after controls have been considered, resulting in an activity being canceled or not being started."
  },
  {
    "key": 254,
    "value": "risk capacity",
    "description": "The amount of loss that an organization can incur without seriously affecting its ability to continue as an organization."
  },
  {
    "key": 255,
    "value": "risk culture",
    "description": "The overall attitude toward risk, promulgated and supported by the organiza-tion\u2019s leadership."
  },
  {
    "key": 256,
    "value": "risk factor",
    "description": "Any factor that may contribute to an increase or decrease in risk; risk factors could be external or internal, and they could affect either likelihood or impact should a risk event actually occur. bbgglloossss__oonnlliinnee..iinndddd 118822//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 257,
    "value": "risk governance",
    "description": "A governance framework to ensure that risk management processes are effective and reflect management\u2019s direction and stakeholder interests."
  },
  {
    "key": 258,
    "value": "risk identification",
    "description": "The realization of a new risk to an organization, its systems, or its processes."
  },
  {
    "key": 259,
    "value": "risk ignorance",
    "description": "The intentional or unintentional act of ignoring a risk that has been identified."
  },
  {
    "key": 260,
    "value": "Risk IT Framework",
    "description": "ISACA\u2019s own risk management methodology; it is strongly tied to and integrated with COBIT. The Risk IT Framework merges traditional IT models with a more risk-focused mindset."
  },
  {
    "key": 261,
    "value": "risk ledger",
    "description": "See risk register."
  },
  {
    "key": 262,
    "value": "risk management",
    "description": "The lifecycle process of managing risk within an organization at all levels, aligned with the organization\u2019s risk appetite, tolerance, and strategy."
  },
  {
    "key": 263,
    "value": "risk mitigation",
    "description": "Involves the application of controls that lower the overall level of risk by reducing the vulnerability, the likelihood of the threat being exploited, or the impact to the asset if the risk were to be realized."
  },
  {
    "key": 264,
    "value": "risk monitoring",
    "description": "Ongoing risk-assessment activities in which risks are periodically reviewed to determine whether the nature of threats, threat actors, vulnerabilities, impact, or probabil-ities of occurrence have changed."
  },
  {
    "key": 265,
    "value": "risk owner",
    "description": "The person ultimately responsible and accountable for a risk."
  },
  {
    "key": 266,
    "value": "risk ownership",
    "description": "The state of being responsible and accountable for a risk."
  },
  {
    "key": 267,
    "value": "risk profile",
    "description": "A collection of detailed data on identified IT risks, typically applied to a specific system or groups of systems."
  },
  {
    "key": 268,
    "value": "risk ranking",
    "description": "The process of ordering risks in a sequence, with the most significant risks appearing first."
  },
  {
    "key": 269,
    "value": "risk realization",
    "description": "The awareness that a potential risk scenario has become actualized."
  },
  {
    "key": 270,
    "value": "risk register",
    "description": "The master product or document that reflects the organization\u2019s different risk scenarios and factors; it can be broken down by asset or system and includes threats, vulner-abilities, assets, likelihood, and impact to assets."
  },
  {
    "key": 271,
    "value": "risk response action plan",
    "description": "A list of the risk responses that have been chosen and the charts of their progress and associated timeline, with an appropriate action owner or owners."
  },
  {
    "key": 272,
    "value": "risk scenario",
    "description": "An identified risk event possibility, which consists of a threat actor, threat, vulnerability, and asset."
  },
  {
    "key": 273,
    "value": "risk sharing",
    "description": "Also known as risk transfer, risk sharing involves using a third party to offset part of the risk. It can involve outsourcing some activities to a third party to reduce the finan-cial impact of a risk event. bbgglloossss__oonnlliinnee..iinndddd 119922//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 274,
    "value": "risk tolerance",
    "description": "The organization\u2019s level of acceptable variation from the risk appetite."
  },
  {
    "key": 275,
    "value": "risk transference",
    "description": "See risk sharing."
  },
  {
    "key": 276,
    "value": "risk treatment",
    "description": "The decision made about the potential action to be taken concerning a spe-cific risk."
  },
  {
    "key": 277,
    "value": "risk triage",
    "description": "Analysis of risks to determine which one(s) warrant attention and action."
  },
  {
    "key": 278,
    "value": "root-cause analysis (RCA)",
    "description": "A method of problem-solving that seeks to identify the root cause of an event or problem."
  },
  {
    "key": 279,
    "value": "router",
    "description": "A device that connects to and facilitates communications between two or more net-works. See also switch."
  },
  {
    "key": 280,
    "value": "Schr\u00f6dinger\u2019s control",
    "description": "A control that appears to be both effective and ineffective, depending upon how one examines it."
  },
  {
    "key": 281,
    "value": "scope creep",
    "description": "The tendency for a project\u2019s scope to slowly grow if not controlled."
  },
  {
    "key": 282,
    "value": "scope",
    "description": "The set of systems, processes, personnel, data, or work centers to be included in an assessment, project, or task."
  },
  {
    "key": 283,
    "value": "Scrum",
    "description": "A formalized, structured implementation of the Agile development methodology. See also Agile."
  },
  {
    "key": 284,
    "value": "security architecture",
    "description": "The overall design of security tools, features, and controls to protect IT infrastructure and data stored there."
  },
  {
    "key": 285,
    "value": "security categorization",
    "description": "The process of determining the impact on the organization regard-ing the confidentiality, integrity, and availability of information and systems. The secu-rity categorization uses qualitative benchmarks of low, moderate, and high. FIPS 199 and NIST Special Publication 800-60 offer a defined process for the security categorization of information."
  },
  {
    "key": 286,
    "value": "security control",
    "description": "A security measure or protection applied to data, systems, people, facilities, or other resources to protect them from adverse events. See also control."
  },
  {
    "key": 287,
    "value": "security incident",
    "description": "An adverse event that compromises, or has the potential to compromise, the confidentiality, integrity, or availability of information assets or systems."
  },
  {
    "key": 288,
    "value": "security incident response (IR)",
    "description": "A formalized set of practices used to detect, analyze, con-tain, eradicate, and recover from security incidents while minimizing business impact and risk exposure."
  },
  {
    "key": 289,
    "value": "security incident response plan",
    "description": "See incident response plan (IRP). bbgglloossss__oonnlliinnee..iinndddd 220022//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 290,
    "value": "security information and event management system (SIEM)",
    "description": "An information system that collects event and log data from systems and devices, performs event correlations, and issues alerts to personnel when security events and incidents occur."
  },
  {
    "key": 291,
    "value": "security orchestration and response (SOAR)",
    "description": "An information system that performs a pre-defined set of tasks when a specific event is detected. A SOAR system may be integrated with a SIEM or another security system to automate otherwise mundane tasks."
  },
  {
    "key": 292,
    "value": "security testing",
    "description": "The testing of a system\u2019s security controls, safeguards, and configurations. See also integration testing, interface testing, unit testing, user acceptance testing (UAT)."
  },
  {
    "key": 293,
    "value": "segregation of duties",
    "description": "See separation of duties."
  },
  {
    "key": 294,
    "value": "semi-quantitative analysis",
    "description": "An assessment technique that uses subjective values, such as scales of 1\u20133, 1\u20135, or 1\u201310, to describe components of risk, such as likelihood and impact. Semi-quantitative techniques rely on data that is often not easily described in numerical terms."
  },
  {
    "key": 295,
    "value": "separation of duties",
    "description": "The process design and access control concept that enforces the rule that no single individual can carry out specific high-value or high-risk tasks."
  },
  {
    "key": 296,
    "value": "serverless architecture",
    "description": "A cloud-based service in which the service provider manages the operating system (OS), and the customer uses and/or manages the software running on the OS."
  },
  {
    "key": 297,
    "value": "service desk",
    "description": "The centralized point of contact in an IT department for users to report issues, request services, and obtain support."
  },
  {
    "key": 298,
    "value": "service-level agreement (SLA)",
    "description": "A contractual agreement, signed by an organization and a third-party provider, that details the level of security, data availability, and other protections afforded to the organization\u2019s data held by the third party."
  },
  {
    "key": 299,
    "value": "shadow IT",
    "description": "The unauthorized use of hardware and software to support business processes."
  },
  {
    "key": 300,
    "value": "shadow risk",
    "description": "See dark risk."
  },
  {
    "key": 301,
    "value": "shared responsibility model",
    "description": "A written definition of operational roles and responsibilities for SaaS/PaaS/IaaS\u2013customer relationships."
  },
  {
    "key": 302,
    "value": "Sherwood Applied Business Security Architecture (SABSA)",
    "description": "A model and methodology for developing an information security architecture."
  },
  {
    "key": 303,
    "value": "shift left",
    "description": "The principle in which cybersecurity is involved as early as possible in software and systems development projects."
  },
  {
    "key": 304,
    "value": "single loss expectancy (SLE)",
    "description": "In quantitative risk analysis, the financial loss when a threat is realized one time."
  },
  {
    "key": 305,
    "value": "sniffer",
    "description": "See protocol analyzer."
  },
  {
    "key": 306,
    "value": "software",
    "description": "A collection of programs, instructions, and data that direct a computer or device to perform specific functions, process information, or control hardware components. bbgglloossss__oonnlliinnee..iinndddd 221122//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 307,
    "value": "Software-as-a-Service (SaaS)",
    "description": "A third-party cloud-based service that provides outsourced software use; this allows an organization to use licensed software at a lower cost than buying, installing, and maintaining hardware and software."
  },
  {
    "key": 308,
    "value": "software composition analysis (SCA)",
    "description": "The practice of analyzing software applications to detect open-source software and determine if they are current, have security vulnerabilities, and have licensing requirements. See also dynamic application security testing (DAST), static application security testing (SAST)."
  },
  {
    "key": 309,
    "value": "software development lifecycle (SDLC)",
    "description": "A framework describing the entire useful life of a software application, which usually includes phases relating to requirements definition, design, development, acquisition, implementation, operations, and disposal. See also systems development lifecycle (SDLC)."
  },
  {
    "key": 310,
    "value": "stakeholder",
    "description": "Any business-related individual, department, or entity directly affected by risk to the organization."
  },
  {
    "key": 311,
    "value": "standard",
    "description": "1) A mandatory, management-approved document that specifies detailed requirements, rules, or configurations for implementing one or more organizational policies. Organizational standards define how policies are implemented in practice and may include technical specifi-cations, configuration requirements, and procedural rules, such as system hardening, encryp-tion, and logging standards. 2) A formally published specification, guideline, or benchmark developed by a recognized standards body, industry consortium, or authoritative organization to prescribe or recom-mend accepted practices, controls, or configurations."
  },
  {
    "key": 312,
    "value": "statement of impact",
    "description": "A qualitative or quantitative description of the impact on an organiza-tion if a process or system is incapacitated for a time."
  },
  {
    "key": 313,
    "value": "static application security testing (SAST)",
    "description": "Tools that analyze source code to identify defects and vulnerabilities. See also dynamic application security testing (DAST), software composi-tion analysis (SCA)."
  },
  {
    "key": 314,
    "value": "strategic risk",
    "description": "Long-term, enterprise-level risk borne by senior management, concerning decisions that affect the organization\u2019s direction, market position, and alignment with risk appetite and tolerance. These risks influence long-range objectives and overall business via-bility. See also operational risk, tactical risk."
  },
  {
    "key": 315,
    "value": "switch",
    "description": "A device that connects to and facilitates communications between devices on a net-work. One or more of those devices may be routers, to facilitate communications between devices on a network and devices on a distant network. See also router."
  },
  {
    "key": 316,
    "value": "systems development lifecycle (SDLC)",
    "description": "A framework describing the entire useful life of a system or software, which usually includes phases relating to requirements definition, design, development, acquisition, implementation, operations, and disposal. See also software devel-opment lifecycle (SDLC). bbgglloossss__oonnlliinnee..iinndddd 222222//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 317,
    "value": "tactical risk",
    "description": "Short-term, localized risk at the lowest operational levels, arising in small work units or production sections performing day-to-day tasks, reflecting immediate, near-term impacts. See also operational risk, strategic risk."
  },
  {
    "key": 318,
    "value": "tailgating",
    "description": "A practice of unauthorized persons following authorized persons through a secu-rity door or entrance."
  },
  {
    "key": 319,
    "value": "technical control",
    "description": "A control that is implemented in an information system. See also adminis-trative control, physical control."
  },
  {
    "key": 320,
    "value": "technical debt",
    "description": "The presence of hardware and software in an IT environment that are no longer supported by their vendors."
  },
  {
    "key": 321,
    "value": "technology risk",
    "description": "Risk associated with failures or weaknesses in systems, platforms, networks, and supporting infrastructure."
  },
  {
    "key": 322,
    "value": "The Open Group Architecture Framework (TOGAF)",
    "description": "A lifecycle enterprise architecture framework used for the design, planning, implementation, and governance of an enterprise architecture."
  },
  {
    "key": 323,
    "value": "third-party risk management (TPRM)",
    "description": "The set of activities used to identify and manage risks associated with the use of external suppliers and service providers."
  },
  {
    "key": 324,
    "value": "threat",
    "description": "An event or occurrence that has the potential to cause harm or damage to people, places, or things or to adversely affect operations."
  },
  {
    "key": 325,
    "value": "threat actor",
    "description": "A person or entity that would carry out a threat if they chose to. See also threat agent."
  },
  {
    "key": 326,
    "value": "threat agent",
    "description": "The means through which a threat is carried out, often by a threat actor. See also threat actor."
  },
  {
    "key": 327,
    "value": "threat analysis",
    "description": "A risk analysis that identifies every threat that has a reasonable probability of occurrence."
  },
  {
    "key": 328,
    "value": "threat assessment",
    "description": "An assessment that attempts to determine all potential threat actors and threats that may affect a given asset or its vulnerabilities. See also threat modeling."
  },
  {
    "key": 329,
    "value": "threat event",
    "description": "A threat that is carried out that causes harm or damage to people, places, or things."
  },
  {
    "key": 330,
    "value": "threat hunting",
    "description": "The proactive search for attacks, attackers, and indicators of compromise."
  },
  {
    "key": 331,
    "value": "threat intelligence platform (TIP)",
    "description": "A system that collects emerging threat information from one or more threat intelligence feeds to assist a SIEM in the identification of events and inci-dents. See also security information and event management system (SIEM)."
  },
  {
    "key": 332,
    "value": "threat landscape",
    "description": "The set of threats that have been identified that are associated with a business activity or business asset. bbgglloossss__oonnlliinnee..iinndddd 223322//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 333,
    "value": "threat modeling",
    "description": "A threat assessment that attempts to determine all possible vectors of attack and includes risk factors that may affect the ability of a threat actor to initiate or complete a threat event. Note that threat modeling differs from threat assessment in that it is specific to a given organization, its assets, and the vulnerabilities determined for it. See also threat assessment."
  },
  {
    "key": 334,
    "value": "threat realization",
    "description": "See threat event."
  },
  {
    "key": 335,
    "value": "three lines of defense",
    "description": "The concept of defense within a risk management framework comprising operational management, risk and compliance management, and audit and accountability."
  },
  {
    "key": 336,
    "value": "triage",
    "description": "See risk triage."
  },
  {
    "key": 337,
    "value": "unauthorized disclosure",
    "description": "Any release, publication, or sharing of information by a party not authorized to do so."
  },
  {
    "key": 338,
    "value": "unit testing",
    "description": "The testing of individual components of a system. See also integration testing, interface testing, security testing, user acceptance testing (UAT)."
  },
  {
    "key": 339,
    "value": "user acceptance testing (UAT)",
    "description": "The testing of a system by its end users as a part of an approval process leading to general release. See also integration testing, interface testing, security testing, unit testing."
  },
  {
    "key": 340,
    "value": "value statement",
    "description": "An organization\u2019s formal declaration of culture or guiding principles."
  },
  {
    "key": 341,
    "value": "vulnerability",
    "description": "A weakness in a system, asset, or process, such as a flaw in software code; it can also be considered a lack of protection for an asset, such as an unlocked server room door."
  },
  {
    "key": 342,
    "value": "vulnerability analysis",
    "description": "Examination of a vulnerability in a system, asset, or process."
  },
  {
    "key": 343,
    "value": "vulnerability assessment",
    "description": "An assessment that seeks to identify potential weaknesses in an asset. This involves identifying the assets that will be covered within the scope of the assessment, conducting scans and other tests against those assets, and providing a report of the vulnerabilities that have been found."
  },
  {
    "key": 344,
    "value": "vulnerability scanner",
    "description": "A software program designed to scan a system to determine what ser-vices the system is running and whether any unnecessary open ports, operating systems and applications, or back doors can be exploited because of a lack of patching or other flaws. See also port scanner. bbgglloossss__oonnlliinnee..iinndddd 224422//1188//22002266 1111::5544::2277 AAMM"
  },
  {
    "key": 345,
    "value": "walkthrough",
    "description": "An interview with a control, process, or system owner as a part of an assessment. A walkthrough may involve an examination of documentation, data, and other artifacts."
  },
  {
    "key": 346,
    "value": "waterfall",
    "description": "A traditional systems development methodology that has given way to more Agile methodologies. See also Agile, Scrum, DevOps, CI/CD, and Infrastructure-as-Code."
  },
  {
    "key": 347,
    "value": "work breakdown structure (WBS)",
    "description": "A detailed decomposition of the work to be performed during the project, including specific step-by-step tasks and required resources."
  },
  {
    "key": 348,
    "value": "workers",
    "description": "An inclusive term that means employees (full-time and part-time), temporary workers, contractors, consultants, and others who are a part of an organization\u2019s workforce."
  },
  {
    "key": 349,
    "value": "XaaS",
    "description": "See Everything-as-a-Service (XaaS)."
  },
  {
    "key": 350,
    "value": "Zachman Framework",
    "description": "An enterprise architecture framework used to describe an IT architec-ture in increasing levels of detail."
  },
  {
    "key": 351,
    "value": "Zero-Trust Architecture (ZTA)",
    "description": "A network architecture model in which user and device access must be verified and validated continually. bbgglloossss__oonnlliinnee..iinndddd 225522//1188//22002266 1111::5544::2277 AAMM bbgglloossss__oonnlliinnee..iinndddd 226622//1188//22002266 1111::5544::2277 AAMM"
  }
];
